import { inject, Injectable } from '@angular/core';

import { RECAPTCHA_SITE_KEY } from '../global/constants';

@Injectable({
    providedIn: 'root',
})
export class RecaptchaLoaderService {
    public recaptchaSiteKey: Promise<string> = inject(RECAPTCHA_SITE_KEY);

    public loadRecaptcha() {
        this.recaptchaSiteKey.then((recaptchaSiteKey) => {
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        });
    }
}
